import { useQuery } from '@tanstack/react-query';

import { leadsApi } from '@/lib/api/leads.api';

import type { LeadQuery } from '@repo/shared-types';

export function useLeads(query?: Partial<LeadQuery>) {
  return useQuery({
    queryKey: ['leads', query],
    queryFn: () => leadsApi.getLeads(query),
  });
}

export function useLead(id: string | undefined) {
  return useQuery({
    queryKey: ['leads', id],
    queryFn: () => leadsApi.getLead(id!),
    enabled: !!id,
  });
}
